module.exports = __webpack_public_path__ + "assets/signout_white.5d2864f6.svg";